/** Ім'я файлу із заголовка Content-Disposition відповіді API. */

/**
 * Ім'я файлу з Content-Disposition: спершу `filename*=UTF-8''…` (RFC 5987, кирилиця), далі `filename="…"` або `filename=…`;
 * без заголовка чи імені — `fallback`. Роздільники шляху замінюються на «_», щоб ім'я не могло вказувати на теку. Чиста функція.
 */
export function fileNameFromDisposition(header: string | null | undefined, fallback: string): string {
  const name = extended(header ?? '') ?? plain(header ?? '');
  const safe = name?.trim().replace(/[\\/]/g, '_');
  return safe ? safe : fallback;
}

function extended(header: string): string | undefined {
  const match = /filename\*\s*=\s*(?:[\w-]+)?'[^']*'([^;]+)/i.exec(header);
  if (!match?.[1]) return undefined;
  try {
    return decodeURIComponent(match[1].trim().replace(/^"|"$/g, ''));
  } catch {
    return undefined;
  }
}

function plain(header: string): string | undefined {
  const match = /filename\s*=\s*(?:"([^"]*)"|([^;]*))/i.exec(header);
  return match ? (match[1] ?? match[2]) : undefined;
}
